import { useApiData } from '@/composables/useApiData';

export const useApiWindAlerts = () => {
  const apiAlertData = useApiData('alert');

  const getAlerts = async (options, overrideCache = false) => await apiAlertData.request('getAlerts', options, overrideCache)
  const addAlert = async (options) => await apiAlertData.request('addAlert', options, true)
  const updateAlert = async (options) => await apiAlertData.request('updateAlert', options, true)
  const deleteAlert = async (options) => await apiAlertData.request('deleteAlert', options, true)
  const changeAlertStatus = async (options) => await apiAlertData.request('changeAlertStatus', options, true)
  const changeAlertStatusForDevice = async (options) => await apiAlertData.request('changeAlertStatusForDevice', options, true)
  const getAlertDevices = async (options, overrideCache = false) => await apiAlertData.request('getAlertDevices', options, overrideCache)
  const addAlertDevice = async (options) => await apiAlertData.request('addAlertDevice', options, true)
  const updateAlertDevice = async (options) => await apiAlertData.request('updateAlertDevice', options, true)
  const deleteAlertDevice = async (options) => await apiAlertData.request('deleteAlertDevice', options, true)
  const getAlertHistory = async (options) => await apiAlertData.request('getAlertHistory', options)

  return {
    getAlerts,
    addAlert,
    updateAlert,
    deleteAlert,
    changeAlertStatus,
    changeAlertStatusForDevice,
    getAlertDevices,
    addAlertDevice,
    updateAlertDevice,
    deleteAlertDevice,
    getAlertHistory
  }
}
